import { Component, OnInit } from '@angular/core';
import { UbicaTuDiputadoService } from './ubica-tu-diputado.service';
import { Observable } from 'rxjs';
import { AngularFireStorage } from '@angular/fire/storage';
import { municipios } from './municipios';




@Component({
  selector: 'ubica-tu-diputado',
  templateUrl: './ubica-tu-diputado.component.html',
  styleUrls: ['./ubica-tu-diputado.component.scss'],
  providers: [UbicaTuDiputadoService]
})
export class UbicaTuDiputadoComponent implements OnInit {


  downloadURL: Observable<any>;
  distritos: Observable<any[]>;
  partidosBD: Observable<any[]>;
  listDistritos: any[];
  listMunicipalities:[];
  perfilFotoURL: Observable<any>;

  politicianDistrictFound: any;
  politiciansMunicipalitiesFound:any[];
  politiciansElectionFound:any[];



  constructor(private politiciansService: UbicaTuDiputadoService, private storage: AngularFireStorage) { }


  ngOnInit() {
    this.distritos = this.politiciansService.getDistricts();
    this.cargarDatosTabla();
    this.section;
    this.electionSelected = 'MR';
    this.distSelected = 1;
    this.municipalitySelected = 14;

  }

  selectOption(id) {
    //getted from event
    this.distSelected = id;
  }

  selectOptionMunicipality(id){
  this.municipalitySelected = id;
  }

  selectOptionElection(election){
  
    this.electionSelected = election;
  }

  diputados: any[];
  senadores: any[];
  partidos: any[];
  id: any[];
  urlFilter: string;
  dURL: Observable<any>;
  buscar: boolean;

  distSelected: number;
  municipalitySelected:number;
  distBySection: any;
  electionSelected:string;

  section: string;


  cargarDatosTabla() {
    this.buscar = true;

    this.listDistritos = [];
    this.listMunicipalities=municipios;

    this.distritos.forEach((poldata) => {
      this.listDistritos = poldata;
    });

  }

  buscarPorDistrito() {
    this.politiciansService.getPoliticianByDistrictID(this.distSelected)
       .subscribe((politicianDB) => {
       this.politicianDistrictFound = politicianDB[0];
       if (this.politicianDistrictFound == null || this.politicianDistrictFound.name == null) {
         alert("Sin resultados, vuelve a intentar")
       } else {
         this.perfilFotoURL = this.storage.ref(this.politicianDistrictFound.image_path).getDownloadURL();
         this.buscar = false;

       }

    })

  }

  buscarPorMunicipio(){
    
    this.politiciansService.getPoliticianByDistrictID(this.municipalitySelected).subscribe((politicianDB) => {
      if(!politicianDB.length){
        alert("Sin resultados, vuelve a intentar")
      }else{
        
        this.politiciansMunicipalitiesFound = politicianDB.map((politician:any)=>{
          politician.image_path = this.storage.ref(politician.image_path).getDownloadURL();
          return politician;
        });
         this.buscar = false;
      }
    })
  }

  buscarPorTipoEleccion(){    
    this.politiciansService.getPoliticianByElection(this.electionSelected).subscribe((politicianDB) => {
      if(!politicianDB.length){
        alert("Sin resultados, vuelve a intentar")
      }else{
        
        this.politiciansElectionFound = politicianDB.map((politician:any)=>{
          politician.image_path = this.storage.ref(politician.image_path).getDownloadURL();
          return politician;
        });
         this.buscar = false;
      }
    })
   
  }




  buscarPorSeccion() {
   
   const districtSelected:any = this.listDistritos.filter((distrito)=>distrito.sections.includes(this.section))
   
      this.politiciansService.getPoliticianByDistrictID(parseInt(districtSelected[0].id_district, 10)).subscribe((politicianDB) => {
      this.politicianDistrictFound = politicianDB[0];
      if (this.politicianDistrictFound == null || this.politicianDistrictFound.name == null) {
        alert("Sin resultados, vuelve a intentarJ");
      } else {
        this.perfilFotoURL = this.storage.ref(this.politicianDistrictFound.image_path).getDownloadURL();
        this.buscar = false;
        this.distBySection = null;
        this.section = null;

      }
    })
  }

  eliminarResultado() {
    this.distritos = this.politiciansService.getDistricts();
    this.cargarDatosTabla();
    this.politiciansMunicipalitiesFound = [];
    this.politiciansElectionFound = [];
    this.buscar = true;
  }


}
